import { SecurityService } from './core/services/security.service';

export function init(securityService: SecurityService) {
  return () => securityService.initialize();
}